/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState } from 'react';
import { AnyObject, Maybe, ObjectSchema } from 'yup';

interface Error {
  [key: string]: string;
}

export function useValidation(
  validationRoles: ObjectSchema<Maybe<AnyObject>, AnyObject, AnyObject, ''>,
  formData: object,
) {
  const [errors, setErrors] = useState<Error>({});

  const validate = async () => {
    try {
      await validationRoles.validate(formData, { abortEarly: false });

      return true;
    } catch (error: any) {
      const newErrors = {} as Error;

      error.inner?.forEach((error: any) => {
        newErrors[error.path || 'list'] = error.message;
      });

      setErrors(newErrors);

      return false;
    }
  };

  return {
    errors,
    validate,
  };
}
